const config = JSON.parse(document.getElementById('configuration').innerHTML)

const {
  contactActionsOrder,
  contact,
  environment,
  locale,
  loggingBaseUrl,
  snowplow,
  tenant
} = config

export default {
  tenant() {
    return config.tenant
  },
  chapiBaseUrl() {
    return config.personalisation.baseUrl
  },
  chapiAuthMode() {
    return config.personalisation.authMode
  },
  requestContext() {
    return config.personalisation.requestContext
  },
  personalisation() {
    return {
      ...config.personalisation,
      analytics: {
        globalContext: window.$spGlobalContext,
        enabled: snowplow.enabled
      },
      tenant: this.tenant()
    }
  },
  personalisationEnabled() {
    return config.personalisation.enabled
  },
  canonicalLinks() {
    return config.canonicalLinks
  }
}

export {
  contactActionsOrder,
  contact,
  environment,
  locale,
  loggingBaseUrl,
  snowplow,
  tenant
}
